import auditTrailFiltersSignal, {
	setAuditTrailFilters,
} from '@UI/Pages/Administration/AuditTrail/Filters/Signals/auditTrailFiltersSignal';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Calendar } from '@verclam/ui-kit';

type Props = {
	readonly withLabel?: boolean;
};

/** Date range written through to the signal immediately; `null` bounds mean an open-ended range. */
const PeriodFilter: React.FC<Props> = ({ withLabel = false }) => {
	const currentFilters = useSignalValue(auditTrailFiltersSignal);

	const periodValue = React.useMemo<(Date | null)[] | null>(() => {
		if (currentFilters.occurredFrom === null && currentFilters.occurredTo === null) {
			return null;
		}

		return [currentFilters.occurredFrom, currentFilters.occurredTo];
	}, [currentFilters.occurredFrom, currentFilters.occurredTo]);

	const handlePeriodChange = React.useCallback((value: (Date | null)[] | null) => {
		const [occurredFrom, occurredTo] = value ?? [null, null];
		setAuditTrailFilters(
			auditTrailFiltersSignal.peek().setPeriod(occurredFrom ?? null, occurredTo ?? null),
		);
	}, []);

	return (
		<Calendar<'range'>
			name="auditTrailPeriod"
			label="Période"
			isLabelHidden={!withLabel}
			placeholder="Du … au …"
			selectionMode="range"
			value={periodValue}
			onChange={handlePeriodChange}
			showIcon
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default PeriodFilter;
